import { render, staticRenderFns } from "./MediacontactCompanyCreate.vue?vue&type=template&id=f3f81890"
import script from "./MediacontactCompanyCreate.vue?vue&type=script&lang=js"
export * from "./MediacontactCompanyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports